import { render } from "./ModifyMemorialView.vue?vue&type=template&id=59238a89"
import script from "./ModifyMemorialView.vue?vue&type=script&lang=js"
export * from "./ModifyMemorialView.vue?vue&type=script&lang=js"

import "./ModifyMemorialView.vue?vue&type=style&index=0&id=59238a89&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__